<template>
    <b-modal title="Cambia Stato" ref="mdlCambiaStato" id="mdlCambiaStato" ok-title="Aggiorna" @ok="onOkCambiaStato">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Nuovo Stato:</label>
                <b-form-select v-model="jsonData.stato" :options="statoOptions" :value="''" value-field="stato" text-field="stato">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Stato - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Data e ora:</label>
                <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="jsonData.dataOra" type="search"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note:</label>
                <b-form-textarea v-model="jsonData.note" rows="7"></b-form-textarea>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    mixins: [UtilityMixin],
    components: { DatePicker },
    data() {
        return {
            statoOptions: [{ stato: "CONCLUSA" }, { stato: "SOSPESA" }, { stato: "IN CORSO" }],
            pathResource: "/rsapazienteprescrizionestati/aggiornastato",

            jsonData: { id: null, stato: null, note: null, dataOra: null },
        };
    },
    methods: {
        show(item) {
            this.jsonData = { id: null, stato: null, note: null, dataOra: null };
            this.jsonData.idRsaPazientePrescrizioni = item.id;
            this.jsonData.dataOra = new Date().getTime();
            this.$refs.mdlCambiaStato.show();
        },

        aggiornaStato() {
            let me = this;

            me.saveResource(me.pathResource, me.jsonData, me.aggiornaStatoSuccess, me.aggiornaStatoError);
        },
        aggiornaStatoSuccess() {
            let me = this;
            this.numeroRecordsSalvati++;
            me.$bvToast.toast("Aggiornamento avvenuto con succedsso ", {
                title: "Elemento Associato",
                variant: "success",
                solid: true,
            });
            me.$emit("cambioStatoSuccess");
            me.closeModal();
        },
        aggiornaStatoError(error) {
            let me = this;
            this.numeroRecordsSalvati++;
            me.allSavedSuccess = false;
            let messaggio = error.response ? error.response.data.messaggio : error.message;
            me.$bvToast.toast("Errore nell'aggiornamento " + messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.closeModal();
        },
        closeModal() {
            this.$refs.mdlCambiaStato.hide();
        },
        onOkCambiaStato(bvModalEvent) {
            bvModalEvent.preventDefault();
            this.aggiornaStato();
        },
    },
};
</script>

<style></style>
